import { render, staticRenderFns } from "./ModalViewInvoice.vue?vue&type=template&id=48867842&scoped=true&"
import script from "./ModalViewInvoice.vue?vue&type=script&lang=js&"
export * from "./ModalViewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewInvoice.vue?vue&type=style&index=0&id=48867842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48867842",
  null
  
)

export default component.exports